<template>
  <div
    class="panel-container alert"
    :class="`alert-${color}`">
    <div
      class="panel-header"
      @click="isExpanded = !isExpanded">
      <ExpandButton
        v-model="isExpanded"
        @click.stop />
      <div class="panel-header-content">
        <div
          v-if="icon"
          class="icon">
          <Component :is="icon" />
        </div>
        <span class="panel-header-text">
          <slot name="header" />
        </span>
      </div>
    </div>

    <transition name="squish">
      <div
        v-if="isExpanded"
        class="panel-content">
        <slot name="expanded-content" />
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
  import { type Component as ComponentType, ref } from 'vue';

  import ExpandButton from '@/common/components/controls/table/ExpandButton.vue';

  interface IProps {
    icon?: ComponentType;
    color?: 'heading' | 'info' | 'danger' | 'success' | 'warning';
  }

  const { color = 'heading' } = defineProps<IProps>();

  const isExpanded = ref<boolean>(false);
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .panel-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 0.6rem;
    margin-top: 1rem;
    margin-bottom: 1rem;

    background-color: var(--paneHeaderBackgroundColor);
  }

  .panel-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;

    gap: 1rem;
    cursor: pointer;
    padding: 0.5rem 1rem;
    border-radius: 0.6rem;

    .panel-header-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: start;
      gap: 1rem;
      width: 100%;
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 2rem;
      min-width: 2rem;
      max-height: 2rem;
      max-width: 2rem;
    }

    &:hover {
      background-color: var(--paneHeaderBackgroundColorDark);
    }
  }

  .panel-content {
    width: 100%;
    padding: 0.5rem;
  }
</style>
